import { render } from "./Form.vue?vue&type=template&id=70bb683a"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=70bb683a&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__